export enum SidebarPanel {
  ELEMENTS = 'elements',
  STYLE = 'style',
  SETTINGS = 'settings',
  LAYOUT = 'layout',
  PAGES = 'pages',
  HISTORY = 'history',
  EDIT = 'edit',
  ADDONS = 'addons'
}
